import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";
import ComplaintService from '../../services/complaint/ComplaintService';
import AppLoading from '../app-loading/app-loading';
//import ComplaintActionSearch from './ComplaintActionSearch';
import ComplaintActionDataTable from './ComplaintActionDataTable';
import { ComplaintActionModel } from '../../models/complaints/complaint-model';
import { complaintActionsExport } from './complaint-actions-export';
import ComplaintActionSearch from './ComplaintActionSearch';

const ComplaintActionMain: React.FC = () => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [filteredActions, setFilteredActions] = useState<ComplaintActionModel[]>([]);
  const [actionList, setActionList] = useState<ComplaintActionModel[]>([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [complaintType, setComplaintType] = useState<'product' | 'service'>('product');

  const [filters, setFilters] = useState<any>({
    complaintType: 'product'
  });

  useEffect(() => {
    const loadComplaintActions = async () => {
      setLoading(true);
      try {
        const response = await ComplaintService.GetAllComplaintActions();
        let initialFiltered = [...response];
        
        if (filters.startDate && filters.endDate) {
          initialFiltered = initialFiltered.filter(action => {
            const actionDate = new Date(action.actionDate || '');
            return actionDate >= filters.startDate && 
                   actionDate <= filters.endDate;
          });
        }

        if (filters.searchKeyword) {
          const searchTerm = filters.searchKeyword.toLowerCase();
          initialFiltered = initialFiltered.filter(action => {
            return Object.values(action).some(value => 
              value?.toString().toLowerCase().includes(searchTerm)
            );
          });
        }

        initialFiltered = initialFiltered.filter(action => {
          if (filters.complaintType === 'product') {
            return action.productComplaintId !== null;
          } else {
            return action.serviceComplaintId !== null;
          }
        });

        setActionList(response);
        setFilteredActions(initialFiltered);
        setTotalRecords(initialFiltered.length);
        setComplaintType(filters.complaintType);
      } catch (error) {
        console.error('Error loading complaint actions:', error);
        setActionList([]);
        setFilteredActions([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };

    loadComplaintActions();
  }, [pageNo, pageSize, filters]);

  const handleSearch = (searchFilters: any) => {
    setPageNo(1);
    setFilters(searchFilters);
  };

  const handlePageChange = async (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    setPageNo(newPageNumber);
    setPageSize(event.rows);
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-center" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <h5 className="ml-1 mb-0">{t("View All Complaint Actions")}</h5>
              <span>
                <Button
                    className="text-black border-round mr-2 mb-1"
                    onClick={() => complaintActionsExport(filteredActions, complaintType)}
                    icon="pi pi-file-export mr-1"
                    text
                    raised
                    tooltip="Export to Excel"
                    tooltipOptions={{ position: 'top' }}
                    >
                    Export All Complaint Actions
                </Button>
              </span>
            </div>
            
            <ComplaintActionSearch
              onSearch={handleSearch}
              setLoading={setLoading}
            />
          </div>
          
          <ComplaintActionDataTable
            data={filteredActions}
            pageNo={pageNo}
            pageSize={pageSize}
            handlepagechange={handlePageChange}
            totalRecordsCount={totalRecords}
            complaintType={complaintType}
          />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default ComplaintActionMain;